import { ItemType } from 'src/constants';
import type { ValidationStatus } from 'src/api/getSchedules/types';
import type { ValidationRule } from 'src/api/validate/types';

export type ValidationItemType =
  | ItemType.STANDARD
  | ItemType.MODIFIER
  | ItemType.BUNDLE
  | ItemType.NON_FOOD
  | 'MODIFIER_GROUP'
  | 'BUNDLE_GROUP';

export enum ValidationErrorKey {
  OPTION_GROUPS_MISSING_ITEMS = 'missing_options_in_group',
  BUNDLE_MISSING_OPTION_GROUP = 'missing_option_group',
  POS_ID = 'missing_pos_id',
  DEFAULT_PRICE = 'missing_default_price',
  TAX_RATE = 'missing_tax_rate',
  NO_DESC = 'missing_description',
  NO_MENU_IMAGE = 'no_menu_image',
  NO_EMPTY_SECTION = 'missing_items_in_section',
  GAP_IN_SCHEDULE = 'gap_in_schedule',
}

export interface IValidationReportRange {
  id: string;
  name: string;
}

export interface IValidationReportPricing {
  price_scheme_id: string;
  name: string;
  errors: ValidationErrorKey[];
}

export interface IValidationReportOptionGroupAssignment {
  item_id: string;
  name: string;
}

export interface IValidationReportItemOptionGroup {
  option_group_id: string;
  option_group_type: ValidationItemType;
  name: string;
  ranges: IValidationReportRange[];
  errors: ValidationErrorKey[];
  assigned_to: IValidationReportOptionGroupAssignment[];
  pricing: IValidationReportPricing[];
}

export interface IValidationReportItem {
  item_id: string;
  name: string;
  item_type: ValidationItemType;
  ranges: IValidationReportRange[];
  pricing: IValidationReportPricing[];
  errors: ValidationErrorKey[];
}

export interface IValidationReportMenu {
  menu_id: string;
  name: string;
  ranges?: IValidationReportRange | null;
  errors: ValidationErrorKey[];
}

export interface IValidationReportTimetable {
  timetable_id: string;
  name: string;
  ranges?: IValidationReportRange | null;
  errors: ValidationErrorKey[];
}

export type IValidationReportErrorSummary = Partial<Record<ValidationErrorKey, number>>;

export interface IValidationReportCriteria {
  price_scheme_id?: string | null;
  schedule_id?: string | null;
  timetable_id?: string | null;
  menu_id?: string | null;
  rules: ValidationRule[];
  excluded_items?: string[];
}

export interface IValidationReport {
  report_id: string;
  generated_at: string;
  status: ValidationStatus;
  criteria: IValidationReportCriteria;
  menu?: IValidationReportMenu | null;
  timetable?: IValidationReportTimetable | null;
  items: IValidationReportItem[];
  option_groups: IValidationReportItemOptionGroup[];
  error_summary: IValidationReportErrorSummary;
}
